export const defaultState = {
  lastQuery:'',
  results:{
    totalResults: 0,
    query: '',
    results: [],
    relatedContent: {}
  },
  categories: [],
};